import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showInboxSettings: false, // Controls visibility of InboxSettings
  showChatInfo: false, // Controls visibility of ChatInfo
  selectedSettings: "All",
  screenSize: "lg", // Default screen size, will be updated based on screen size detection
  selectedTeamMember: null,
  selectedTeam: null,
  // Add selectedInboxTab for tab/filter UI
  selectedInboxTab: "All", // Can be "All", "You", team member id, or team id
  // One-shot flag: when true, InboxAll.jsx's tab-change effect skips clearing the
  // open chat/URL for the next selectedInboxTab change. Set by MessageCard.jsx when
  // it auto-corrects the sidebar tab to reveal a deep-linked Closed/Blocked contact,
  // so that intentional correction doesn't immediately wipe the selection it just made.
  skipNextTabChangeClear: false,
  // Contact id (or null): set right when a "closechat"/"blockcontact" socket event closes
  // the chat the user is CURRENTLY viewing, so MessageCard.jsx's tab auto-correction effect
  // (which normally jumps the sidebar to "Closed"/"Blocked Contacts" so a Closed/Blocked
  // contact is findable in the list) can skip itself for exactly this one contact — Rahim,
  // 2026-09-18: "when i close a convo i still want ... the left panel to [not] change me to
  // close panel". Left null (auto-correction runs as normal) for the other case that
  // mechanism exists for: deep-linking straight into a chat that was ALREADY closed/blocked
  // before it was ever opened, where the sidebar still needs to jump so the contact is
  // visible in whatever list is showing.
  skipNextTabAutoCorrectContactId: null,
};

const inboxSlice = createSlice({
  name: "inbox",
  initialState,
  reducers: {
    setInboxSettings: (state, action) => {
      state.showInboxSettings = action.payload; // Set visibility of InboxSettings
    },
    setChatInfo: (state, action) => {
      state.showChatInfo = action.payload; // Set visibility of ChatInfo
    },
    setScreenSize: (state, action) => {
      state.screenSize = action.payload; // Update screen size state
    },
    setSelectedSettings: (state, action) => {
      state.selectedSettings = action.payload;
    },
    toggleInboxSettings: (state) => {
      state.showInboxSettings = !state.showInboxSettings; // Toggle InboxSettings visibility
    },
    toggleChatInfo: (state) => {
      state.showChatInfo = !state.showChatInfo; // Toggle ChatInfo visibility
    },
    setSelectedTeamMember(state, action) {
      state.selectedTeamMember = action.payload;
    },
    setSelectedTeam(state, action) {
      state.selectedTeam = action.payload;
    },
    setSelectedInboxTab(state, action) {
      state.selectedInboxTab = action.payload;
    },
    markSkipNextTabChangeClear(state) {
      state.skipNextTabChangeClear = true;
    },
    clearSkipNextTabChangeClear(state) {
      state.skipNextTabChangeClear = false;
    },
    markSkipTabAutoCorrect(state, action) {
      state.skipNextTabAutoCorrectContactId = action.payload;
    },
    clearSkipTabAutoCorrect(state) {
      state.skipNextTabAutoCorrectContactId = null;
    },
  },
});

export const {
  setInboxSettings,
  setChatInfo,
  setScreenSize,
  setSelectedSettings,
  toggleInboxSettings,
  toggleChatInfo,
  setSelectedTeamMember,
  setSelectedTeam,
  setSelectedInboxTab, // Export new action
  markSkipNextTabChangeClear,
  clearSkipNextTabChangeClear,
  markSkipTabAutoCorrect,
  clearSkipTabAutoCorrect,
} = inboxSlice.actions;

export default inboxSlice.reducer;
